import { toastConfig, ToastHelper } from '@hub/shared'
import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const allowedErrors = [
  'unauthorized',
  'unexpected',
  'access_denied',
  'too_many_attempts',
  'unregistered_user',
  'unregistered_user_mq',
  'mail_verified',
  'contract_refused',
  'not_allowed',
]

export default () => {
  const toast = useMemo(() => new ToastHelper().toast, [])
  const [t] = useTranslation('useMessage')

  const showMessage = useCallback(
    ({ message = '', type = 'warning', duration = 3600000, onClick }: toastConfig) => {
      if (type === 'error') {
        message = `${allowedErrors.includes(message) ? message : 'unexpected'}`
      }
      toast[type](t(`${message}`), {
        closeButton: true,
        className: 'full text-bold',
        position: `${window.innerWidth > 991 ? 'top' : 'bottom'} center`,
        duration,
        notOverClick: true,
        immediately: true,
        onClick,
      })
    },
    [toast, t]
  )

  return { showMessage }
}
